var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 166,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.1515 53.0259C74.9258 52.7047 76.2038 55.4586 78.042 56.649C80.3207 58.126 83.8869 58.2452 86.3916 57.3452C89.4071 56.2606 90.9263 52.1662 94.371 53.247C95.6983 53.6624 102.318 57.4779 103.345 58.4221C105.531 60.4337 103.999 61.853 103.778 64.0684C103.376 68.1301 104.741 71.9494 108.436 73.911C110.523 75.0187 113.981 74.9976 114.68 77.7226C115.092 79.3285 115.054 85.1363 114.857 86.9306C114.217 92.7519 106.999 90.2018 104.409 96.2443C102.519 100.654 106.101 105.2 102.981 107.937C102.069 108.737 94.4659 112.954 93.5145 112.997C91.0174 113.108 89.6445 110.437 87.9279 109.325C85.6453 107.846 82.0772 107.731 79.5782 108.629C76.7887 109.631 74.9144 113.66 71.8591 112.849C70.7121 112.545 64.0886 108.775 62.9929 107.929C60.3287 105.875 61.9523 104.323 62.1916 101.904C62.5922 97.8462 61.2326 94.025 57.5335 92.0615C55.4465 90.9537 51.9886 90.9749 51.2898 88.2498C50.8302 86.4536 50.891 78.5477 51.662 76.9707C52.7709 74.7033 56.453 74.7226 58.65 73.1629C60.9421 71.5359 62.1764 69.1186 62.2523 66.2897C62.4004 60.7011 59.1855 60.5222 65.3172 56.6394C66.5515 55.8586 71.0197 53.1509 72.1515 53.0201V53.0259ZM81.4126 72.5764C68.3232 74.3899 70.5583 94.9885 84.2439 93.4596C97.7359 91.9538 95.516 70.6205 81.4126 72.5764Z",
    fill: "#94B5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.e7c789dbbd4d725647e58ba16aab9f60.svg";
export { ForwardRef as ReactComponent };